// extracted by mini-css-extract-plugin
export default {"root":"CompanyAdminForm_root__Nv4mt","container":"CompanyAdminForm_container__URcBy"};